export default __webpack_public_path__ + "static/media/30.26f3df5a.gif";